import { css, polished } from 'jimu-core';
export const toastStyles = (props) => {
    return css `
    background-color: transparent;
    border: 0;
    box-shadow: 0 0 0;
    position: fixed;
    top: 90px;
    left: 0;
    right: 0;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2001;
    .jimu-toast-common{
      box-shadow: 0 2px 6px 0 ${polished.rgba(props.theme.ref.palette.white, 0.2)};
      font-size: 16px;
      font-weight: 500;
      border-radius: 2px;
    }
    .jimu-toast-error{
      background-color: ${props.theme.ref.palette.black};
      color: ${props.theme.sys.color.error.main};
      .jimu-icon{
        color: ${props.theme.sys.color.error.main};
      }
    }
    .jimu-toast-info{
      background-color: ${props.theme.sys.color.secondary.main};
      color: ${props.theme.ref.palette.black};
    }
  `;
};
